export const CONVERSION_LOCATION = {
    SPECIFIC_PAGE: 'SPECIFIC_PAGE',
    CROSS_SITE: 'CROSS_SITE',
};

export const CROSS_SITE_BUTTON_TYPE = {
    COMBINE_SAME_TEXT_BUTTONS: 'COMBINE_SAME_TEXT_BUTTONS',
    COMBINE_BUTTONS_THAT_CONTAINS_URL: 'COMBINE_BUTTONS_THAT_CONTAINS_URL',
};
